module.exports = __webpack_public_path__ + "img/Graph-2.6d92e609.svg";